import React, { Component } from 'react';
import TickerTitle from './TickerTitle';
import TickerScale from './TickerScale';
import TickerPrice from './TickerPrice';
import { getColor } from '../../../../../../models/market-map/data-parser';
import './index.css';


class Ticker extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.handleMouseHover = this.handleMouseHover.bind(this);
  }

  handleMouseHover(e){
    const { ticker } = this.props;
    this.props.onMouseHover(e, ticker)
  }

  render() {
    const { ticker, hover, hoverColor, showPrice } = this.props;
    const { w,h,t,l } = ticker.position;
    //console.log('Ticker showPrice --------- ', showPrice)
    return (
      <div id='sc-market-map-ticker-container'
        onMouseEnter={this.handleMouseHover}
        style={{width:w+1, height:h+1, top:t, left:l,
          border:hover ? `2px solid ${hoverColor}`:null,
          backgroundColor: getColor(ticker.color),
          backgroundImage : isNaN(ticker.color) ?
          'repeating-linear-gradient( -45deg, #111, #111 5px,  #333 5px, #333 10px)'
          : getColor(ticker.color),
        }}>
        <TickerTitle ticker={ticker}/>
        <TickerScale ticker={ticker}/>
        {showPrice && <TickerPrice ticker={ticker}/>}
      </div>
    );
  }
}



export default Ticker;




